<template>
  <ym-item class="pay-center-delivery-component"
           title="配送方式"
  >
    <div class="pay-center-delivery-value">
      <span class="pay-center-delivery-type">{{ type }}</span>
      <span class="pay-center-delivery-price"
            v-html="deliveryPrice"
      ></span>
    </div>
  </ym-item>
</template>

<script>
  import PayCenterItem from '@/pages/Pay/components/PayCenterItem';

  export default {
    name: 'PayCenterDelivery',
    components: {
      'ym-item': PayCenterItem,
    },
    props: {
      type: String,
      price: Number,
    },
    computed: {
      deliveryPrice() {
        const { price } = this;
        if (price === 0) {
          return '免运费';
        }
        if (price === -1) {
          return '超出配送范围';
        }
        if (price === -2) {
          return '请选择地址';
        }
        return `¥${price}`;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .pay-center-delivery {
    &-type {
      margin-right: @size-extra-small;
    }

    &-price {
      color: @color-text-highlight;
    }
  }
</style>
